import { InputTextAnswerLogic as InputTextAnswer } from './InputTextAnswer.logic'

export default InputTextAnswer
